import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, serchSelectManage, tabulation } from "@/mixins/index";
import { getPamseList, delePamseMange } from "@/api/dataAll/pamseMange";
import addPamse from "./components/addPamseMange";
export default {
  name: "detePamseManger",
  components: {
    addPamse: addPamse
  },
  mixins: [serchSelect, serchSelectManage, tabulation],
  data: function data() {
    return {
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      showing: false,
      sels: [],
      selsString: "",
      searchData: {
        page_size: 10,
        page: 1,
        game: "",
        platform: "",
        type: '',
        op_ad_channel: 'jl'
      },
      opAdChannel: [{
        label: "巨量",
        value: 'jl'
      }, {
        label: "广点通",
        value: 'gdt'
      }],
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      typeForms: [{
        id: "1",
        type_name: 'click'
      }, {
        id: "2",
        type_name: 'show'
      }],
      InitializeOrNot: false
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      getPamseList(this.searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this.searchData.page > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
            _this.total = res.data.total - 0 || 0;
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleSource: function handleSource(id) {
      this.$refs.addWayConfig.init(id);
    },
    handleClipboard: function handleClipboard(text, event) {
      var _this3 = this;

      this.$copyText(text).then(function (e) {
        _this3.$Message.success('复制成功');
      }, function (e) {
        this.$Message.success('复制失败');
      });
    },
    deleAll: function deleAll(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该监测参数, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delePamseMange({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.searchClick(_this4.searchData.page);

                    _this4.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};